import React, { useEffect, useRef } from 'react';
import {
	imgBrandsOt7BrandMarkSvg,
	imgBrandsOtSelectBrandMarkSvg,
	imgBrandsOteBrandMarkSvg,
	imgBrandsOtxBrandMarkSvg,
	imgOvertimeWordmarkReversedSvg,
} from '~/src/images';
import styles from '~/src/lib/styles.json';
// import { shop, ote } from './Header.module.css';
import './Header.scss';

export default function Header({ sticky = true, backgroundColor = styles.COLOR.BRAND_PRIMARY_DARK }) {
	const headerRef = useRef<HTMLElement>();
	useEffect(() => {
		if (typeof window !== 'undefined') {
			if (location.search.includes('embed')) {
				headerRef.current?.remove();
			}

			const onScroll = () => {
				const header = headerRef.current;
				if (!header) {
					return;
				}
				if (header.getBoundingClientRect().y < 40) {
					header.style.opacity = '1';
				} else {
					header.style.opacity = '0';
				}
			};
			window.addEventListener('scroll', onScroll);

			return () => {
				window.removeEventListener('scroll', onScroll);
			};
		}
	}, []);

	return (
		<header
			ref={headerRef}
			className="Header"
			style={{
				zIndex: '2',
				padding: `${styles.SIZE.GAP_HALF} ${styles.SIZE.GAP}`,
				marginTop: '0',
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gridColumn: 'full',
				background: backgroundColor,
				paddingTop: styles.SIZE.GAP_HALF,
				paddingBottom: styles.SIZE.GAP_HALF,
				transition: 'opacity 0.2s ease',
				top: '0',
				left: '0',
				opacity: '1',
				position: sticky ? 'sticky' : 'absolute',
			}}
		>
			<div
				style={{
					width: '100%',
					maxWidth: styles.SIZE.CONTENT_WIDTH,
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					height: '32px',
					alignItems: 'center',
				}}
			>
				<div
					style={{
						width: '100%',
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'start',
						alignItems: 'center',
						height: '32px',
					}}
				>
					<a href="/" style={{ marginRight: '24px' }}>
						<img
							alt="Overtime"
							style={{
								display: 'block',
							}}
							src={imgOvertimeWordmarkReversedSvg}
						/>
					</a>
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						gap: '6px',
					}}
				>
					<a className={'HeaderOte'} href="https://overtimeelite.com" title="OTE">
						<img
							style={{
								display: 'block',
							}}
							src={imgBrandsOteBrandMarkSvg}
							alt="OTE"
						/>
					</a>
					<a className={'HeaderOT7'} href="https://otseven.com/" title="OT7">
						<img
							style={{
								display: 'block',
							}}
							src={imgBrandsOt7BrandMarkSvg}
							alt="OT7"
						/>
					</a>
					<a className={'HeaderOTX'} href="https://otboxing.com/" title="OTX">
						<img
							style={{
								display: 'block',
							}}
							src={imgBrandsOtxBrandMarkSvg}
							alt="OTX"
						/>
					</a>
					<a className={'HeaderOTSelect'} href="https://overtimeselect.com/" title="OT Select">
						<img
							style={{
								display: 'block',
							}}
							src={imgBrandsOtSelectBrandMarkSvg}
							alt="OT Select"
						/>
					</a>
					<a
						className={'HeaderShop'}
						style={{
							display: 'flex',
							fontFamily: styles.FONT.HIGHLIGHT,
							fontSize: '13px',
							color: 'white',
							textTransform: 'uppercase',
							textDecoration: 'none',
							fontWeight: 'bold',
							letterSpacing: '-0.25px',
							marginLeft: '8px',
							alignItems: 'center',
						}}
						href={'https://shop.overtime.tv'}
					>
						<div
							style={{
								backgroundColor: 'white',
								padding: '8px',
								borderRadius: '4px',
								textTransform: 'uppercase',
								color: '#333',
								fontSize: '14px',
								fontWeight: '700',
							}}
						>
							Shop
						</div>
					</a>
				</div>
			</div>
		</header>
	);
}
